import React, { Fragment } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Divider, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonFormField from "../../common/components/CommonFormField";

const CareerAlignment = ({
    formData,
    handleInputChange,
    errors
}) => {
    return (
        <CommonCard
            paddingBottom="0px"
            border={`1px solid #0000001A`}
            borderRadius={2}
            padding="0px"
            background="#F9DFCD"
            headerContent={
                <Fragment>
                    <Box p={2}>
                        <Typography fontWeight={600} fontSize={18}>College & Career Alignment</Typography>
                        <Typography fontSize={14} color={theme.palette.background.dark}>Add your Skill & Experience Assessment</Typography>
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Grid container spacing={2} p={2}>
                    <Grid item md={12}>
                        <CommonFormField
                            label="How will this project support your college profile?"
                            type="email"
                            name="collegeProjectSupport"
                            value={formData.collegeProjectSupport}
                            onChange={handleInputChange}
                            placeholder="Describe here"
                            error={errors.collegeProjectSupport}
                            multiline
                        />
                    </Grid>
                    <Grid item md={12}>
                        <CommonFormField
                            label="What career path are you interests"
                            type="email"
                            name="careerPathInterest"
                            value={formData.careerPathInterest}
                            onChange={handleInputChange}
                            placeholder="Describe here"
                            error={errors.careerPathInterest}
                            multiline
                        />
                    </Grid>
                </Grid>
            }
        />
    )
}

export default CareerAlignment;